"use client";

import React, { useRef } from "react";
import topCurveGreyRight from "@/app/assets/top-curve-grey-right.svg";
import Image from "next/image";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

type CurveProps = {
    color: String;
    direction: String;
    className: React.ReactNode;
};

export default function TopCurves({ color, direction, className }: CurveProps) {
    const curveRef = useRef(null);

    let imageSrc = null;

    switch (true) {
        case direction === "right" && (color === "grey" || color === "white"):
            imageSrc = topCurveGreyRight;
            break;
        default:
            break;
    }

    useGSAP(() => {
        // Target the two specific elements we have asigned the animate class
        gsap.timeline({
            scrollTrigger: {
                trigger: curveRef.current,
                start: "bottom 65%",
                end: "bottom -100%",
                toggleActions: "play reverse play reverse",
                scrub: 1,
            },
        }).to(curveRef.current, {
            scaleY: 0.5,
            transformOrigin: "top",
        });
    });

    return (
        <div
            className={
                "absolute top-0 left-0 right-0 m-auto -mt-1 w-full h-auto pointer-events-none z-0 " +
                className
            }
            ref={curveRef}
        >
            {imageSrc && (
                <Image
                    src={imageSrc}
                    width={1920}
                    height={260}
                    alt="background image"
                    className="w-full"
                />
            )}
        </div>
    );
}
